import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * テスト計画作成インスタンス詳細のインデックス。
 *
 * _layout 化により本文は `_layout/detail` へ移設したため、ここではタブ無し
 * アクセスを「詳細」タブへリダイレクトする（PN「リリース判定」と同パターン）。
 */
export const Route = createFileRoute('/_stacktrace/qa-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/qa-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/detail',
      params
    });
  }
});